import { BaseProfile, IProfile } from "./profiles";
import { UserSource } from "./source";
import { getUser } from "./index";

interface TrakheesiRole {
	RoleId: number;
	RoleNameAr: string;
	RoleNameEn: string;
}

interface TrakheesiUserObject {
	ParticipantId: number;
	UserId: number;
	SsoAccountId: number;
	UserName: string;
	PersonNameAr: string;
	PersonNameEn: string;
	UserPhoneNo: string;
	UserMobileNo: string;
	UserFaxNo: string;
	UserEmail: string;
	VerifyState: number;
	RolesList: TrakheesiRole[];
}

export interface ITrakheesiProfile extends IProfile {
	UserName: string;
	Email: string;
	Mobile: string;
	PersonNameAr: string;
	PersonNameEn: string;
	RoleId: number;
	UserObject: TrakheesiUserObject;
	IsAdminUser: boolean;
	UserType: number;
	SsoAccountId: number;
}

export class TrakheesiProfile extends BaseProfile implements ITrakheesiProfile {
	UserName: string;
	Email: string;
	Mobile: string;
	PersonNameAr: string;
	PersonNameEn: string;
	RoleId: number;
	UserObject: TrakheesiUserObject;
	IsAdminUser: boolean;
	UserType: number;
	SsoAccountId: number;

	constructor( profile: ITrakheesiProfile ) {
		super( UserSource.TRAKHEESI, profile.RoleId );
		this.UserName = profile.UserName;
		this.Email = profile.Email;
		this.Mobile = profile.Mobile;
		this.PersonNameAr = profile.PersonNameAr;
		this.PersonNameEn = profile.PersonNameEn;
		this.RoleId = profile.RoleId;
		this.UserObject = profile.UserObject;
		this.IsAdminUser = profile.IsAdminUser;
		this.UserType = profile.UserType;
		this.SsoAccountId = profile.SsoAccountId;
	}

	static buildProfile( profile: ITrakheesiProfile ): TrakheesiProfile {
		const p = new TrakheesiProfile( profile );
		return p;
	}

	static getProfile(): TrakheesiProfile | undefined {
		const u = getUser();
		if ( u )
			return u.getProfile( UserSource.TRAKHEESI ) as TrakheesiProfile;
		return undefined;
	}

	getUserType() {
		return this.UserType;
	}

	getUserRole() {
		return this.RoleId;
	}

	getTrakheesiUserSsoAccountId() {
		return this.SsoAccountId;
	}
}
